"use client"

import React, { useState, useEffect, useRef, version } from 'react';

import DataTableListGenerica from '../DataTableListGenerica/DataTableListGenerica'
import DataTableGenerica from './DataTableGenerica'
import DataTableGenericaPreguntaFormato from './DataTableGenericaPreguntaFormato'
import DataTableListGenericaRaw from '../DataTableListGenerica/DataTableListGenericaRaw'



import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { ScrollPanel } from 'primereact/scrollpanel';

import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import AuthStorage from '../../storage/AuthStorage';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
//import Link from 'next/link';
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Panel } from 'primereact/panel';
import { RadioButton } from 'primereact/radiobutton';

import Document from './Document';

import lodash from "lodash";

import { htmlToText } from "html-to-text";
import wordsCount from 'words-count';

import crypto from "crypto-js";
import "./FormularioGenerico.css";


const FormularioGenerico = React.forwardRef((props, ref) => {

    console.log("FormularioGenerico, ");
    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();
    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const genericaSistemaService = new GenericaSistemaService();

    const etiquetasModulo = props.etiquetasModulo;
    //const selectedTipoGenerica = props.selectedTipoGenerica;

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    //const [modoEdicion, setModoEdicion] = useState(false);
    const [tgPreguntaReferenciada, setTgPreguntaReferenciada] = useState("BAS_REFERENCIA-REF_FMT_VSTA_RESPUESTA_REFERENCIADA_ITEM");

    const metadataGenericaSistemaForm = props.metadataGenericaSistemaForm;

    const [selectedColumns, setSelectedColumns] = useState([]);
    const [optionsSelectButton, setOptionsSelectButton] = useState(undefined);
    const genericaSistemaDialog = props.genericaSistemaDialog;

    const [visibleConfirm, setVisibleConfirm] = useState(false);

    const valorFocoText = useRef("");

    const inicioAutomatico = useRef(true);
    const esPrimerLoad = useRef(true);


    const validarOptionsSelectButtonRef = useRef(false);
    const guardando = useRef(false);
    const [modoEdicion, setModoEdicion] = useState(true);

    const genericaSistemaDialogRef = useRef(null);
    const toast = useRef(null);

    const [loadingLazyData, setLoadingLazyData] = useState(false);
    const [creandoFormulario, setCreandoFormulario] = useState(false);
    const [comodin, setComodin] = useState(0);

    const [loadingData, setLoadingData] = useState(false);


    const _ = lodash;

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);

    const refBtGuardarDialogFooter = useRef(undefined);

    const prevSelectedTipoGenericaRef = useRef(undefined);
    const clasificadorOperacionRef = useRef("PROD");
    const campoRespuestaFormatoDiligenciadoRef = useRef("respuestaFormatoDiligenciado");

    const lazyParamInit = {
        first: 0,
        rows: 1000,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            //'ctiTexto': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const [guidIntento, setGuidIntento] = useState(window.crypto.randomUUID());

    const [lazyParams, setLazyParams] = useState(undefined);
    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));


    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    const [selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO, setSelectedTipoGenerica_FORMULARIO_GENERICO_INTENTO] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO, setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE, setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE, setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA, setSelectedTipoGenerica_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA] = useState(undefined);

    const [camposAMostrar_FORMULARIO_GENERICO_INTENTO, setCamposAMostrar_FORMULARIO_GENERICO_INTENTO] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO, setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE, setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_DETALLE, setCamposAMostrar_FORMULARIO_GENERICO_DETALLE] = useState("");

    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_INTENTO, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_INTENTO] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE] = useState([]);

    const [metadataGenericaSistemaForm_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA, setMetadataGenericaSistemaForm_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA] = useState([]);

    const [genericasSistema_FORMULARIO_GENERICO_INTENTO, setGenericasSistema_FORMULARIO_GENERICO_INTENTO] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO, setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_NOTAPADRE, setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_DETALLE, setGenericasSistema_FORMULARIO_GENERICO_DETALLE] = useState(null);

    const [genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA, setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA] = useState(null);

    const [genericaSistema, setGenericaSistema] = useState({ ...props.genericaSistema });

    if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) || props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema_FORMULARIO_GENERICO_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(null);
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema_FORMULARIO_GENERICO_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(null);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
            setGenericasSistema_FORMULARIO_GENERICO_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(null);
        }

    }

    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [editando, setEditando] = useState(false);

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });


    //const [genericaSistema, setGenericaSistema] = useState(emptyGenericaSistemaInit); 


    ref = genericaSistemaDialogRef

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    useEffect(() => {

        if (selectedTipoGenerica.tipoOrganizacionContenido === "FORM_GENERICA"
        ) {

            let prevselectedTipoGenerica = { ...selectedTipoGenerica }
            let isEmpty = _.isEqual({}, selectedTipoGenerica);

            if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined && !isEmpty) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 0;
            }
            else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined && !isEmpty) {

                if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = 0;
                }
                else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
                }
                else {
                    //console.log("setLazyParams");
                    setLazyParams({ ...lazyParams });
                }

            }

            prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

        }

    }, [selectedTipoGenerica])

    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        //lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "") {

            if ((selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                    let newSelectedTipoGenerica = data.data;

                    if (selectedTipoGenerica.filtroUts !== undefined) {
                        newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                        newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                    }
                    if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenerica.variableRestriccionExterna = {};
                    }

                    if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (selectedTipoGenerica.version !== undefined) {
                        newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                    }

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                });
            }

            //else{}

            if (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0) {
                console.log("entro");
                //else if (metadataGenericaSistema.length === 0 && selectedTipoGenerica.operaciones !== undefined) {

                await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(async data => {


                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    /*data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });*/

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = [...data];
                    //let _metadataGenericaSistemaTgOperaciones = data.map(x => x);
                    //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    if (dataRef.length > 0) {

                        setSelectedColumns([]);
                        //setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        //lazyParamInit.filters = createHeaderGenerica(dataForm);

                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data);

                        /*
                        setMetadataGenericaSistemaRef([...dataRef]);
                        setMetadataGenericaFormulario([...dataForm]);
                        setMetadataGenericaFormularioFactura([...dataForm]);

                        setSelectedTipoGenericaFormulario({ ...selectedTipoGenerica });
                        setSelectedTipoGenericaFormularioFactura({ ...selectedTipoGenerica });

                        */

                        if (selectedTipoGenerica.operaciones) {
                            let _canEditRow = selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW");
                            //setCanEditRow( (props.canEditRow | true) && selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));
                        }

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(_metadataGenericaSistemaTgOperaciones, false, guidIntento);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                    }

                });





            }
        }

    }

    const establecerTipoGenericasFORMULARIO_CALIFICACION = async (_metadataGenericaSistemaTgOperaciones, editando, guidIntento) => {


        clasificadorOperacionRef.current = editando === true ? "TMP" : "PROD";
        campoRespuestaFormatoDiligenciadoRef.current = editando === true ? "respuestatmpFormatoDiligenciado" : "respuestaFormatoDiligenciado";

        let tipoTgRef = "FORMULARIO_GENERICO_INTENTO";

        let metadataTgOperacionTgRef = [];
        let operaciontgRef = {};
        let newSelectedTipoGenericaTgRef = {};

        let newFiltroUts = { ...selectedTipoGenerica.filtroUts };

        if (editando) {
            newFiltroUts['guidintentoDiligenciamiento'] = guidIntento;
        }


        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//)
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        var guid = window.crypto.randomUUID();

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }

        let newitemFORMULARIO_GENERICO_INTENTO = { ...newSelectedTipoGenericaTgRef };

        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_CONSOLIDADO";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//&& operaciontgRef.tipoOperacion === "EDIT")
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }


        let newitemFORMULARIO_GENERICO_CONSOLIDADO = { ...newSelectedTipoGenericaTgRef };


        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_NOTAPADRE";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//&& operaciontgRef.tipoOperacion === "EDIT")
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }


        let newitemFORMULARIO_GENERICO_NOTAPADRE = { ...newSelectedTipoGenericaTgRef };

        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_DETALLE";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//&& operaciontgRef.tipoOperacion === "EDIT")
                break;
        }

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }

        let newitemFORMULARIO_GENERICO_DETALLE = { ...newSelectedTipoGenericaTgRef };

        setSelectedTipoGenerica_FORMULARIO_GENERICO_INTENTO(newitemFORMULARIO_GENERICO_INTENTO);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO(newitemFORMULARIO_GENERICO_CONSOLIDADO);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE(newitemFORMULARIO_GENERICO_NOTAPADRE);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE(newitemFORMULARIO_GENERICO_DETALLE);


        setCamposAMostrar_FORMULARIO_GENERICO_INTENTO("guid,intentoCalificacion");

        let _camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO = "nota";
        let _camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE = "nota";
        let _camposAMostrar_FORMULARIO_GENERICO_DETALLE = "nota";

        if (selectedTipoGenerica.tg === "FMT_FORMATO-0") {
            _camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO = "formato";
            _camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE = "segmento";
            _camposAMostrar_FORMULARIO_GENERICO_DETALLE = "pregunta";
        }

        setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO(_camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO);

        if (selectedTipoGenerica.tg === "FMT_FORMATO-0") {
            setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE("ctiTextoDesc");
            setCamposAMostrar_FORMULARIO_GENERICO_DETALLE("ctiTextoDescpregunta");
        }
        else {
            setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE("ctiTextorap,nota,ctiTextoDescnivelDesempeñoRRAP");
            setCamposAMostrar_FORMULARIO_GENERICO_DETALLE("ctiTextocriterioRA,nivelCriterioRA,nota");
        }

        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_INTENTO(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_INTENTO.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));

        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_CONSOLIDADO.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));
        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_NOTAPADRE.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));
        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_DETALLE.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO);
        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE);
        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE);

        let newSelectedColumns = [];
        newSelectedColumns = _metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE.filter(col => (_camposAMostrar_FORMULARIO_GENERICO_DETALLE.includes(col.campo)));

        setSelectedColumns(newSelectedColumns);

        if (clasificadorOperacionRef.current === 'TMP') {

            if (newitemFORMULARIO_GENERICO_NOTAPADRE.operaciones === undefined || newitemFORMULARIO_GENERICO_NOTAPADRE.operaciones.length === 0) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, newitemFORMULARIO_GENERICO_NOTAPADRE.tg).then(data => {

                    let newSelectedTipoGenericaNotaPadre = data.data;

                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.filtroUts !== undefined) {
                        newSelectedTipoGenericaNotaPadre.filtroUts = { ...newitemFORMULARIO_GENERICO_NOTAPADRE.filtroUts };
                        newSelectedTipoGenericaNotaPadre.ctiTextoFiltroUts = newitemFORMULARIO_GENERICO_NOTAPADRE.ctiTextoFiltroUts
                    }
                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenericaNotaPadre.variableRestriccionExterna = { ...newitemFORMULARIO_GENERICO_NOTAPADRE.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenericaNotaPadre.variableRestriccionExterna = {};
                    }

                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.operacionesCampos == undefined || !_.isEqual(newitemFORMULARIO_GENERICO_NOTAPADRE.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenericaNotaPadre.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.version !== undefined) {
                        newSelectedTipoGenericaNotaPadre.version = newitemFORMULARIO_GENERICO_NOTAPADRE.version;
                    }

                    setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE(newSelectedTipoGenericaNotaPadre);

                });
            }

            if (newitemFORMULARIO_GENERICO_DETALLE.operaciones === undefined || newitemFORMULARIO_GENERICO_DETALLE.operaciones.length === 0) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, newitemFORMULARIO_GENERICO_DETALLE.tg).then(data => {

                    let newSelectedTipoGenericaDetalle = data.data;

                    if (newitemFORMULARIO_GENERICO_DETALLE.filtroUts !== undefined) {
                        newSelectedTipoGenericaDetalle.filtroUts = { ...newitemFORMULARIO_GENERICO_DETALLE.filtroUts };
                        newSelectedTipoGenericaDetalle.ctiTextoFiltroUts = newitemFORMULARIO_GENERICO_DETALLE.ctiTextoFiltroUts
                    }
                    if (newitemFORMULARIO_GENERICO_DETALLE.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenericaDetalle.variableRestriccionExterna = { ...newitemFORMULARIO_GENERICO_DETALLE.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenericaDetalle.variableRestriccionExterna = {};
                    }

                    if (newitemFORMULARIO_GENERICO_DETALLE.operacionesCampos == undefined || !_.isEqual(newitemFORMULARIO_GENERICO_DETALLE.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenericaDetalle.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (newitemFORMULARIO_GENERICO_DETALLE.version !== undefined) {
                        newSelectedTipoGenericaDetalle.version = newitemFORMULARIO_GENERICO_DETALLE.version;
                    }

                    setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE(newSelectedTipoGenericaDetalle);

                });
            }

        }


        //let newtgRefSelectItem = undefined;
        //newtgRefSelectItem = selectedTipoGenerica.operaciones.find(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "FORMULARIO_LIST_ITEM");
        //if (newtgRefSelectItem !== undefined)
        //setTgSelectItem(newtgRefSelectItem.tgRef);


    }

    useEffect(() => {
        // 2. Función que actualiza el estado al cambiar el tamaño
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // 3. Escuchar el evento de cambio de tamaño
        window.addEventListener('resize', handleResize);

        // 4. Limpiar el evento cuando el componente se desmonta
        return () => window.removeEventListener('resize', handleResize);
    }, []); // El arreglo vacío asegura que esto solo se ejecute al montar

    useEffect(() => {

        if (lazyParams !== undefined && selectedTipoGenerica !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE !== undefined
        ) {
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadLazyData = () => {
        setLoadingLazyData(true);

        //if (loadLazyTimeout) {
        //clearTimeout(loadLazyTimeout);
        //}

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        let filtroUts = {};
        let _filtroUtsValido = true;
        let _mensajeFiltroUtsValido = "";

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                    if (selectedTipoGenerica.filtroUts[campo] === null || selectedTipoGenerica.filtroUts[campo] === undefined) {
                        _filtroUtsValido = false;
                        let campoInvalido = metadataGenericaSistema.find(x => x.tg === selectedTipoGenerica.tg && x.campo === campo);
                        _mensajeFiltroUtsValido = _mensajeFiltroUtsValido + ", " + campoInvalido.ctiTexto;
                    }

                }
            }
        }

        if (editando) {
            filtroUts['guidintentoDiligenciamiento'] = guidIntento;
        }

        //setFiltroUtsValido(_filtroUtsValido);

        if (!_filtroUtsValido) {

            _mensajeFiltroUtsValido = _mensajeFiltroUtsValido.substring(2, _mensajeFiltroUtsValido.length);

            //setMensajeFiltroUtsValido("Debe seleccionar los siguientes campos en las tablas de arriba -> " + _mensajeFiltroUtsValido);

            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([]);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE([]);
            console.log("cambio");
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE([]);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA([]);

            //setTotalRecords(0);
            setLoadingLazyData(false);
            //setComodin(prev => prev + 1);


        }
        else {

            if (esPrimerLoad.current && inicioAutomatico.current) {

                esPrimerLoad.current = false;

                setEditando(true);
                setModoEdicion(true);
                setSubmitting(false);
                onEditarFormularioFactura();
            }

            else {
                let clasificadorOperacionTg = editando === true ? "TMP" : "PROD";

                genericaSistemaService.getGenericasSistemaDS(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts, clasificadorOperacionTg).then(data => {
                    //setMetadataGenericaSistema(data.metadata);


                    if (data.metadata.length > 0
                        //&& selectedTipoGenerica.tipoTabla == "10" 
                        //&&  ((metadataGenericaSistema.find(x => x.idTipoAtributo >= 999) === undefined) 
                        //&& (data.metadata.find(x => x.idTipoAtributo >= 999) !== undefined))
                    ) {
                        //if ( selectedTipoGenerica.tipoTabla =="10" && data.metadata.length>0 && (( metadataGenericaSistema.length===0) || ( metadataGenericaSistema.length>0 && data.metadata[0].tg !== metadataGenericaSistema[0].tg )) ){

                        let dataRef = data.metadata.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                        let _metadataGenericaSistemaTgOperaciones = data.metadata;
                        let newSelectedColumns = data.metadata;//metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                        let dataForm = newSelectedColumns;

                        if (dataRef.length > 0) {

                            //setSelectedColumns([]);

                            setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                            lazyParamInit.filters = {};
                            //lazyParamInit.filters = createHeaderGenerica(dataForm);
                            let newLazyParamInit = Object.assign({}, lazyParamInit);
                            //console.log("lazyParamInit, ", lazyParamInit);

                            setMetadataGenericaSistema(data.metadata);

                            //setMetadataGenericaSistemaRef(dataRef);
                            //setMetadataGenericaFormulario(dataForm);
                            //setMetadataGenericaFormularioFactura(dataForm);

                            //setSelectedTipoGenericaFormulario(selectedTipoGenerica);
                            //setSelectedTipoGenericaFormularioFactura(selectedTipoGenerica);

                            //setLazyParams({ ...newLazyParamInit });
                            //lazyParamsInitSelected.current = newLazyParamInit;
                            //setSelectedColumns(newSelectedColumns);

                            //if (selectedTipoGenerica.operaciones)
                            //setCanEditRow(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));

                            //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);
                            //setGenericaFormulario(emptyGenericaSistema);
                            //setGenericaFormularioFactura(emptyGenericaSistema);

                        }
                    }

                    //console.table(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE.tg));
                    if (clasificadorOperacionTg === "TMP") {
                        let ddd = "::";
                    }

                    let _genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA = data.data.filter(x => x.tg === "BAS_REFERENCIA-REF_FMT_VSTA_RESPUESTA_REFERENCIADA_ITEM");

                    validarOptionsSelectButtonRef.current = _genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.length > 0;

                    setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(_genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA);


                    setGenericasSistema_FORMULARIO_GENERICO_INTENTO(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO.tg));

                    let _genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO.tg);
                    setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(_genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO);

                    let _genericasSistema_FORMULARIO_GENERICO_NOTAPADRE = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE.tg);
                    setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(_genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);

                    let _genericasSistema_FORMULARIO_GENERICO_DETALLE = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg);

                    if (_genericasSistema_FORMULARIO_GENERICO_DETALLE.length > 0) {
                        _genericasSistema_FORMULARIO_GENERICO_DETALLE.forEach(g => {
                            g['formRef'] = null;
                            g.uts['valido'] = g.uts['valido'] ? g.uts['valido'] === true : false;
                            g.uts['ingresado'] = g.uts['ingresado'] ? g.uts['ingresado'] === true : false;
                            g.uts['valorOrig'] = g.uts['valor'];
                        });
                    }

                    setGenericasSistema_FORMULARIO_GENERICO_DETALLE(_genericasSistema_FORMULARIO_GENERICO_DETALLE);

                    //setGenericasSistema(data.data)
                    //setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
                    setLoadingLazyData(false);
                    //setComodin(prev => prev + 1);



                });

            }


        }

    }

    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['tg'] = selectedTipoGenerica.tg;
        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;
            else {

                let newVal = "";
                if (selectedTipoGenerica.filtroUts !== undefined && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo)) {
                    newVal = selectedTipoGenerica.filtroUts[x.campo];

                }

                item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }
            }
        });


        return item;

    }

    const onBooleanChange = (e, campo) => {

        const val = (e.checked && e.checked) || false;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const onInputChange = (e, pregunta) => {


        const val = (e.target && e.target.value) || e.htmlValue || '';

        valorFocoText.current = ({ pregunta: pregunta['uts']['pregunta'], valor: pregunta['uts']['valor'] });

        let valValid = true;

        let _newPregunta = { ...pregunta };

        if (_newPregunta['uts']['tipoDato'] == "string" && _newPregunta['uts']['formatoDato'] !== "" && _newPregunta['uts']['formatoDato'] !== undefined) {
            valValid = true; // Falta colocar los validadores
            if (_newPregunta['uts']['formatoDato'] === ("EMAIL")) {
                //console.log(validateEmail(val));
                valValid = validateEmail(val) !== null;
            }
        }
        else if (_newPregunta['uts']['tipoDato'] == "text") {
            valValid = true; // Falta colocar los validadores

            if (_newPregunta['uts']['restriccionFormatoMin'] !== undefined && _newPregunta['uts']['restriccionFormatoMin'] !== ""
                && _newPregunta['uts']['restriccionFormatoMax'] !== undefined && _newPregunta['uts']['restriccionFormatoMax'] !== ""
            ) {

                let minWords = Number(_newPregunta['uts']['restriccionFormatoMin']);
                let maxWords = Number(_newPregunta['uts']['restriccionFormatoMax']);
                //console.log(validateEmail(val));
                let countWords = wordsCount(htmlToText(val));


                valValid = countWords >= minWords && countWords <= maxWords;

            }

        }

        _newPregunta['uts']['valido'] = valValid;
        _newPregunta['uts']['valor'] = val;

        let index = genericasSistema_FORMULARIO_GENERICO_DETALLE.findIndex(x => x.id === _newPregunta.id);
        genericasSistema_FORMULARIO_GENERICO_DETALLE[index] = _newPregunta;

        setComodin(x => x + 1);

        //setGenericaSistema(_genericaSistema);
    }

    const onInputNumberChange = (e, campo) => {
        const val = e.value || 0;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    /*
    useEffect(() => {
        if (genericaSistemaDialog && metadataGenericaSistemaForm.length > 0) {
            setTimeout(() => {
                
                let tieneFoco = false;
                for ( let i in metadataGenericaSistemaForm)
                  {

                    let primerCampo = metadataGenericaSistemaForm[i];
                    
                    switch (primerCampo.tipoDato) {
                        case "boolean": primerCampo.formRef.getElement().focus(); break;
                        case "date":  break;
                        case "ref":   break;
                        case "label":   break;
                        case "file":   break;
                        default:  if (primerCampo.formRef!== null){
                            primerCampo.formRef && primerCampo.formRef.inputRef ? primerCampo.formRef.inputRef.current.focus() : primerCampo.formRef.focus(); 
                            tieneFoco=true;
                            break;
                            }
                            else break;
                            
                    }

                    if (tieneFoco)
                        break;

                }

                
            }, 100);

        }

    }, [genericaSistemaDialog]);*/


    const generarCabeceraFormulario = () => {

        //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

        //console.log("metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, ", genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);

        //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(

        let datoFormato = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

        //console.log("datoFormato, ", datoFormato);

        return (
            <div className="field descripcionFormulario">


                <div className="m-0" dangerouslySetInnerHTML={{ __html: datoFormato.uts['ctiTextoDescformato'] }} />
            </div>
        );

    }


    const headerTemplateSegmento = (options) => {
        const className = `${options.className} justify-content-space-between`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <span className="font-bold">Amy Elsner</span>
                </div>

            </div>
        );
    };

    const footerTemplateSegmento = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between gap-3`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <Button icon="pi pi-user" rounded text></Button>
                    <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
                </div>
                <span className="p-text-secondary">Updated 2 hours ago</span>
            </div>
        );
    };


    const generarSegmentosFormularioGenericaSistemaSeleccionada = () => {

        //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

        //console.log("sección, ", genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);

        //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(
        let _genericasSistema_FORMULARIO_GENERICO_NOTAPADRE = genericasSistema_FORMULARIO_GENERICO_NOTAPADRE.filter(segmento => genericasSistema_FORMULARIO_GENERICO_DETALLE.some(detalle => detalle.uts["segmento"] === segmento.uts["segmento"].toString()));

        return _genericasSistema_FORMULARIO_GENERICO_NOTAPADRE

            //setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(_genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);
            //.filter(x => ( x.campo === "nivelCriterioRA") || (x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false))
            .map((genericaNotaPadre, index, array) => {
                //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false).map((metadata, index, array) => {
                //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label").map((metadata, index, array) => {

                return (<>
                    <div className="field sticky-thc" >
                        {
                            <>
                                <label className='tituloSeccion' htmlFor={genericaNotaPadre.uts['segmento']}>{genericaNotaPadre.uts['ctiTexto']}</label>

                                <div className="descripcionSeccion" dangerouslySetInnerHTML={{ __html: genericaNotaPadre.uts['ctiTextoDesc'] }} />
                            </>
                        }





                        <div className=''>
                            {generarCamposFormularioGenericaSistemaSeleccionada(genericaNotaPadre.uts['segmento'])}
                        </div>


                    </div>

                </>);

            });

    }

    const generarCamposFormularioGenericaSistemaSeleccionada = (_segmento) => {

        if (_segmento !== undefined) {
            let segmento = "" + _segmento.toString();
            //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

            //console.log("metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, ", genericasSistema_FORMULARIO_GENERICO_DETALLE);

            //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(

            let campoTipoDato = "tipoDato";
            let camporefFactorForma = "refFactorForma";

            //console.log("segmento,", _segmento);

            let groupAnt = "";
            let primerPreguntaGroup = -1;

            let tamFormulario = (windowSize.width < 640 ? windowSize.width : 640);
            let tamSeccionPregunta = tamFormulario * 0.20;
            let tamSeccionPreguntaPX = tamSeccionPregunta + "px";
            let tamSeccionRespuestas = tamFormulario * 0.78;
            let tamSeccionRespuestasPX = tamSeccionRespuestas + "px";
            let tamSpan = tamFormulario * 0.02;
            let tamSpanPX = tamSpan + "px";

            let porcPant = (tamFormulario < (640 * 0.75) ? 1.5 : 1);
            let tamPant = porcPant * tamFormulario;


            let items = [];

            return genericasSistema_FORMULARIO_GENERICO_DETALLE.filter(preg => preg.uts["segmento"] === segmento)
                //.filter(x => ( x.campo === "nivelCriterioRA") || (x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false))
                .map((genericaNotaDetalle, index, array) => {

                    //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false).map((metadata, index, array) => {
                    //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label").map((metadata, index, array) => {

                    if (genericaNotaDetalle['uts'][campoTipoDato] === "ref") {

                        if (genericaNotaDetalle['uts'][camporefFactorForma] === "selectbutton" && primerPreguntaGroup < 0) {
                            primerPreguntaGroup = index;
                        }

                        let formatoDatoRef = genericaNotaDetalle['uts'][`${"formatoDato"}`];
                        let campoCtiTextoOptionsSelectButton = 'ctiTextovalor';
                        let campoOptionsSelectButton = 'valor';


                        items = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.filter(x => x.tg === tgPreguntaReferenciada && x.uts["tgRef"] === formatoDatoRef
                            && x.uts["tgRef"] === formatoDatoRef).map(x => ({ ...x, value: x.uts[campoOptionsSelectButton] + '', 'name': x.uts[campoCtiTextoOptionsSelectButton] }));


                        porcPant = items.length < 2 ? 1 : (tamFormulario < (640 * 0.75) ? 1.5 : 1);
                        tamPant = porcPant * tamFormulario;


                        let tamRad = ((tamPant * 0.5 / items.length) - 5);

                        let tamTotal = tamPant + tamSeccionPregunta + tamSpan + (items.length * 5);

                        if (primerPreguntaGroup === index) {



                            //porcPant = items.length < 3 ? 0.75 : (windowSize.width < 400 ? 1.5 : 0.75);
                            //porcPant = (windowSize.width < 768 ? 1.5 : 1);

                            //tamPant = porcPant * windowSize.width;



                            //console.log("primerPreguntaGroup", tamRad, porcPant, tamTotal);

                            return (<>

                                <div className="field radioButtonTextSection"
                                    style={{

                                        width: tamTotal + "px",


                                    }}>
                                    {generarRadioButtonTextSection(genericaNotaDetalle, tamSeccionPregunta, tamSeccionRespuestas, tamSpan, tamPant, tamRad)}
                                </div>


                                <div className="field preguntaSeccion" style={{
                                    display: 'inline-flex',
                                    flexDirection: 'row',
                                    flexWrap: 'nowrap',
                                    width: tamTotal + "px",

                                    alignItems: 'flex-start',

                                }}>



                                    <div className="preguntaLabel" style={{ flexShrink: 0, width: tamSeccionPreguntaPX }} dangerouslySetInnerHTML={{ __html: genericaNotaDetalle.uts['ctiTextoDescpregunta'] }} />

                                    <div className="preguntaLabel vertical-align-top" style={{ flexShrink: 0, marginLeft: tamSpanPX, width: tamSeccionRespuestasPX }} >

                                        {generarPregunta(genericaNotaDetalle, tamPant, tamRad)}
                                        {
                                            //generarMensajeValidacionCampo(genericaNotaPadre)
                                        }
                                    </div>


                                </div>
                            </>
                            );

                        }

                        return (<>
                            <div className="field preguntaSeccion" style={{
                                display: 'inline-flex',
                                flexDirection: 'row',
                                flexWrap: 'nowrap',
                                width: tamTotal + "px",

                                alignItems: 'flex-start',

                            }}>
                                <div className="preguntaLabel" style={{ flexShrink: 0, width: tamSeccionPreguntaPX }} dangerouslySetInnerHTML={{ __html: genericaNotaDetalle.uts['ctiTextoDescpregunta'] }} />

                                <div className="preguntaLabel vertical-align-top" style={{ flexShrink: 0, marginLeft: tamSpanPX, width: tamSeccionRespuestasPX }} >

                                    {generarPregunta(genericaNotaDetalle, tamPant, tamRad)}
                                    {
                                        //generarMensajeValidacionCampo(genericaNotaPadre)
                                    }
                                </div>


                            </div>

                        </>);

                    }
                    else {
                        return (<>
                            <div className="field">
                                <div className="preguntaLabel" yle={{ display: 'inline-block', width: '20%' }} dangerouslySetInnerHTML={{ __html: genericaNotaDetalle.uts['ctiTextoDescpregunta'] }} />
                                {generarPregunta(genericaNotaDetalle)}
                                {
                                    //generarMensajeValidacionCampo(genericaNotaPadre)
                                }

                            </div>

                        </>);
                    }

                });

        }
        else { return (<></>); }

    }

    const onSelectedItem = (e, metadataRef) => {


        let _genericasNotaDetalle = [];

        genericasSistema_FORMULARIO_GENERICO_DETALLE.forEach(x => {
            let newGenericaDetalle = { ...x }
            newGenericaDetalle.formRef = x.formRef;
            _genericasNotaDetalle.push(newGenericaDetalle);
        });

        let genericaDetalle = _genericasNotaDetalle.find(x => x.uts["pregunta"] === metadataRef.referenciaRef);

        if (genericaDetalle !== null) {

            const val = e['uts'][`${metadataRef.refCampoTg}`] || '';
            const ValText = Object.keys(e['uts']).includes(`ctiTexto${metadataRef.refCampoTg}`) ? e['uts'][`ctiTexto${metadataRef.refCampoTg}`] : Object.keys(e['uts']).includes(`ctiTexto`) ? e['uts'][`ctiTexto`] : "";

            console.log("dfdf", val, ValText);
            if (metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE.find(x => x.campo === metadataRef.campo)) {

                genericaDetalle['uts'][`${metadataRef.campo}`] = val;
                genericaDetalle['uts'][`ctiTexto${metadataRef.campo}`] = ValText;
            }
            else
                genericaDetalle[`${metadataRef.campo}`] = val;

            console.log("metadataRef, ", val, ValText);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(_genericasNotaDetalle);

            //let element = genericaDetalle.formRef.getElement();
            if (genericaDetalle.formRef) {

                if (genericaDetalle.formRef.close) {
                    genericaDetalle.formRef.close();
                }
                else if (genericaDetalle.formRef.hide)
                    genericaDetalle.formRef.hide();
            }

        }

    }



    const renderHeaderTemplateEditor = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }

    const headerTemplateEditor = renderHeaderTemplateEditor();

    const generarPregunta = (pregunta, tamPant, tamRad) => {


        let campoTipoDato = "tipoDato";
        let campoFormatoDato = "formatoDato";
        let campoValor = "valor";

        let tipoDato = pregunta['uts'][`${campoTipoDato}`] | "string";

        if (tipoDato === "string") {
            campoValor = "valor";
        }
        else if (tipoDato == "int" || tipoDato == "double" || tipoDato == "double") {
            campoValor = "valorNumber";
        }
        else if (tipoDato == "text") {
            campoValor = "valorTexto";
        }
        else if (tipoDato == "date") {
            campoValor = "valorDateTime";
        }
        else
            campoValor = "valor";

        let val = pregunta['uts'][`${campoValor}`];


        let refTg = { "tg": pregunta['uts'][`${campoFormatoDato}`], "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": pregunta.ctiTexto };

        const valRef = pregunta['uts'][`${"ctiTexto" + pregunta.campo}`];
        //pregunta['formRef']

        if (false) {
            //if (metadata.actualizableEnFormulario === false) {

            switch (pregunta['uts'][campoTipoDato]) {
                case "boolean":
                    val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                    return (<Checkbox checked={val} ref={e => pregunta.formRef = e} ></Checkbox>);
                case "int": return (<InputNumber value={val} ref={e => pregunta.formRef = e} readOnly />);
                case "sequence": return (<InputNumber readOnly value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "double": return (<InputNumber mode="decimal" value={val} ref={e => pregunta.formRef = e} readOnly />);
                case "text": return (<div className="m-0" ref={e => pregunta.formRef = e} dangerouslySetInnerHTML={{ __html: val }} />);
                case "text1": return (<InputTextarea value={val} ref={e => pregunta.formRef = e} onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "refDocument":


                    if (genericaSistema.id > -100) {

                        const valRefDoc = genericaSistema['uts'][`${"guid" + pregunta.campo}`];

                        let sequenceTgContenedor = "";

                        if (genericaSistema['uts'][`${selectedTipoGenerica.cgCampo}`] !== undefined) {
                            sequenceTgContenedor = genericaSistema['uts'][`${selectedTipoGenerica.cgCampo}`];
                        }
                        else {
                            let guid = window.crypto.randomUUID();
                            console.log(guid);

                            sequenceTgContenedor = guid;

                        }

                        //console.log("sequenceTgContenedor, ", selectedTipoGenerica, "genericaSistema, ", genericaSistema);
                        //if (genericaSistema.id>0){
                        //{(valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== "") ? (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"../file?guid=" + valRefDoc}>Adjunto</Link>) : <span>No hay archivos cargados</span>}
                        return (
                            <div className={classNames({ 'fieldCustom p-invalid': !pregunta.uts['valido'] && pregunta.ingresado })}>
                                <div>

                                </div>

                            </div>

                        );

                    }
                    else { return (<span>Archivo no carga </span>) }
            }

        }
        else {

            switch (pregunta.uts['tipoDato']) {
                case "boolean":
                    val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                    return (<Checkbox id={`bt${pregunta.id}`} checked={val} ref={e => pregunta.formRef = e} onChange={(e) => onBooleanChange(e, pregunta.campo)} ></Checkbox>);
                case "int": return (<InputNumber id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "sequence": return (<InputNumber id={`bt${pregunta.id}`} readOnly value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "double": return (<InputNumber id={`bt${pregunta.id}`} mode="decimal" value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "text": return (<div className={classNames({ 'fieldCustom p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })}><Editor translate='no' id={`bt${pregunta.id}`} headerTemplate={headerTemplateEditor} style={{ height: '10rem' }} value={val} ref={e => pregunta.formRef = e} onTextChange={(e) => onInputChange(e, pregunta)} /></div>);
                case "text2": return (<InputTextarea id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} onChange={(e) => onInputChange(e, pregunta)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar id={`bt${pregunta.id}`} showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy"
                    value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar id={`bt${pregunta.id}`} showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy"
                    value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "ref2": return (<Inplace closable ref={e => pregunta.formRef = e} style={{ width: '95%' }}>
                    <InplaceDisplay>
                        {valRef || val} || 'Click para editar'
                    </InplaceDisplay>
                    <InplaceContent>
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={pregunta}></DataTableListGenerica>
                    </InplaceContent>
                </Inplace>);
                case "ref":

                    let campoCtiTextoOptionsSelectButton = 'ctiTextovalor';
                    let campoOptionsSelectButton = 'valor';
                    let formatoDatoRef = pregunta['uts'][`${"formatoDato"}`];

                    val = pregunta['uts'][`${"valor"}`];
                    const valRef = pregunta['uts'][`${"ctiTextovalor"}`];

                    let items = [];

                    if (pregunta.uts['refFactorForma'] === "selectbutton") {

                        items = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.filter(x => x.tg === tgPreguntaReferenciada
                            && x.uts["tgRef"] === formatoDatoRef).map(x => ({ ...x, value: x.uts[campoOptionsSelectButton] + '', 'name': x.uts[campoCtiTextoOptionsSelectButton] }));

                        //<RadioButton inputId="ingredient1" name="pizza" value="Cheese" onChange={(e) => setIngredient(e.value)} checked={ingredient === 'Cheese'} />



                        return (<>
                            <div style={{ display: 'flex', gap: '5px', width: tamPant + "px", marginTop: '8px' }}>

                                {items.map(x => (
                                    <div key={`radio-${x.value}`} style={{ flex: 1, display: 'flex', justifyContent: 'center', width: tamRad + "px" }}>
                                        <RadioButton
                                            inputId={x.value}
                                            value={x.value}
                                            className={"text-center " + classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })}
                                            onChange={(e) => {
                                                if (e.value !== null) onChangeSelectButton({ rowData: pregunta, newValue: e.value, field: campoOptionsSelectButton, originalEvent: e })
                                            }}
                                            checked={val === x.value}
                                        />
                                    </div>
                                ))}
                            </div>
                        </>);




                    }
                    else if (pregunta.uts['refFactorForma'] === "selectbutton") {


                        items = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.filter(x => x.tg === tgPreguntaReferenciada
                            && x.uts["tgRef"] === formatoDatoRef).map(x => ({ ...x, value: x.uts[campoOptionsSelectButton] + '', 'name': x.uts[campoCtiTextoOptionsSelectButton] }));;

                        return (
                            <SelectButton value={val} optionLabel="name" itemTemplate={selectButtonBodyItemTemplate}
                                options={items} style={{ display: "flex" }} disabled={submitting}
                                onChange={(e) => { if (e.value !== null) onChangeSelectButton({ rowData: pregunta, newValue: e.value, field: campoOptionsSelectButton, originalEvent: e }) }}
                                className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })}
                            //onChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }}
                            //let { rowData, newValue, field, originalEvent: event } = e;

                            //readOnly={true} 
                            />
                        );


                    }
                    else {

                        // para los casos que obligatoriamente se van a consultar como listado desplegable

                        //const valRef = genericaSistema['uts'][`${"ctiTexto" + pregunta.campo}`];


                        //let refTg = { "tg": pregunta.uts['formatoDato'], "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": pregunta.uts['ctiTextoformatoDato'] };

                        let refTg = {
                            "tg": "BAS_REFERENCIA-REF_FMT_VSTA_RESPUESTA_REFERENCIADA_ITEM",
                            "cti": pregunta.uts['ctiTextoformatoDato'] || pregunta.uts['formatoDato']
                        };
                        let metadataRef = {
                            "tg": pregunta.uts['formatoDato'], //selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg,
                            campo: "valor",
                            refCampoTg: "valor",
                            tipoDato: pregunta.uts['tipoDato'],
                            referenciaRef: pregunta.uts['pregunta'],
                            formatoDato: pregunta.uts['formatoDato'],
                            camposFiltroRef: 'valor,ctiTextovalor,ctiTextoDescvalor',
                            formRef: pregunta.formRef,
                        };

                        //refTg.filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                            refTg.tg = metadata.dominioDato;
                        }*/

                        if (pregunta.esSoloLectura) {
                            return (<div className={classNames({ 'fieldCustom p-invalid': !pregunta.uts['valido'] && pregunta.ingresado })}>

                                <span>{valRef}</span>

                            </div>);
                        }
                        else {
                            return (<div className={classNames({ 'fieldCustom p-invalid': !pregunta.uts['valido'] && pregunta.ingresado })}>


                                <Button id={`bt${pregunta.uts[campoRespuestaFormatoDiligenciadoRef.current]}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para editar'} style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${pregunta.uts[campoRespuestaFormatoDiligenciadoRef.current]}`)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                                <OverlayPanel ref={e => pregunta.formRef = e} showCloseIcon style={{ width: '60rem', 'margin-top': '2%', 'margin-left': '2%' }} className="overlaypanel-demo">
                                    <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadataRef} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                                </OverlayPanel>
                            </div>);
                        }

                    }
                case "refDep": return (<div className={classNames({ 'fieldCustom': true }, { 'p-invalid': !pregunta.uts['valido'] })}>

                    <Button id={`bt${pregunta.uts[campoRespuestaFormatoDiligenciadoRef.current]}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para editar'} ref={e => pregunta.formRef = e}
                        style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${pregunta.campo}`)}
                        aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                    <OverlayPanel ref={e => pregunta.formRef = e} showCloseIcon style={{ width: '25rem', 'margin-top': '5%', 'margin-left': '5%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={pregunta.metadata}>
                        </DataTableListGenerica>
                    </OverlayPanel>
                </div>);

                default: return (<InputText id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} required
                    onChange={(e) => onInputChange(e, pregunta)} minLength={pregunta.uts["restriccionFormatoMin"] !== "" ? pregunta.uts["restriccionFormatoMin"] + 0 : undefined} maxLength={pregunta.uts["restriccionFormatoMax"] !== "" ? Number(pregunta.uts["restriccionFormatoMax"]) : undefined} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })}
                    onBlur={(e) => {
                        onChangeSelectButton({ rowData: pregunta, newValue: e.target.value, field: "valor", originalEvent: e, originalEvent2: "text" })
                    }}

                />);

            }

        }


    }

    const generarRadioButtonTextSection = (pregunta, tamSeccionPregunta, tamSeccionRespuestas, tamSpan, tamPant, tamRad) => {


        let campoTipoDato = "tipoDato";
        let campoFormatoDato = "formatoDato";
        let campoValor = "valor";

        let val = pregunta['uts'][`${campoValor}`];


        let campoCtiTextoOptionsSelectButton = 'ctiTextovalor';
        let campoOptionsSelectButton = 'valor';
        let formatoDatoRef = pregunta['uts'][`${"formatoDato"}`];

        val = pregunta['uts'][`${"valor"}`];
        const valRef = pregunta['uts'][`${"ctiTextovalor"}`];

        let items = [];

        //if (pregunta.uts['refFactorForma'] === "selectbutton") {

        if (true) {

            items = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.filter(x => x.tg === tgPreguntaReferenciada
                && x.uts["tgRef"] === formatoDatoRef).map(x => ({ ...x, value: x.uts[campoOptionsSelectButton] + '', 'name': x.uts[campoCtiTextoOptionsSelectButton] }));

            //<RadioButton inputId="ingredient1" name="pizza" value="Cheese" onChange={(e) => setIngredient(e.value)} checked={ingredient === 'Cheese'} />

            //console.log("items, ", items);

            return (<>

                <div className="preguntaLabel" style={{ display: 'inline-block', width: tamSeccionPregunta + "px" }} >&nbsp;</div>

                <div className="preguntaLabel vertical-align-top" style={{ display: 'inline-block', marginLeft: tamSpan + "px", width: tamSeccionRespuestas + "px" }} >

                    <div style={{ display: 'flex', gap: '5px', width: tamPant + "px" }}>
                        {items.map(x => {
                            return (<div key={`text-${x.value}`} className=''
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    // Ajusta este valor según el largo máximo de tus textos
                                    minHeight: '45px',
                                    display: 'flex',
                                    alignItems: 'center', // Centra el texto verticalmente
                                    justifyContent: 'center',
                                    width: tamRad
                                }}>
                                <span style={{ fontSize: '13px', lineHeight: '1.2' }}>{x.name}</span>
                            </div>)
                        })}
                    </div>

                </div>


            </>);


        }
    }

    const onFocusCampo = async (e) => {

        let { rowData, field } = e;

        //console.log("onFocusCampo", rowData);

        valorFocoText.current = (e.rowData.formRef.value);

    }

    const onChangeSelectButton = async (e) => {

        let { rowData, newValue, field, originalEvent: event, originalEvent2 } = e;
        let valorOrig = rowData.uts["valorOrig"];

        console.log("onCellEditComplete11, ", rowData.uts["valorOrig"], field, newValue);

        // validaciones varias que aún están programadas.

        setSubmitted(true);
        setLoadingData(true);


        if ((newValue !== undefined && rowData.uts[field] !== newValue) || (originalEvent2 === "text" && valorOrig !== rowData.uts["valor"])) {

            let tgRefOps = selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.operacionesCampos.find(x => x.tipoOperacion === "EDIT_ROW")

            let genericaSistema = { id: rowData.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {

                    if (itemOpsCampo.campotg === field)
                        genericaSistema.uts[itemOpsCampo.campotgRef] = newValue;
                    else
                        genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

                }
            }

            //genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

            genericaSistema.uts['valido'] = true
            genericaSistema.uts['ingresado'] = true

            //[field] = newValue;
            let campoCriterio = 'valor';

            if (field === campoCriterio) {
                //let valCriterio = options.rowData.uts[campoCriterio];
                let itemSelected = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.find(x => x.tg === tgPreguntaReferenciada
                    && x.uts[campoCriterio] + '' === newValue);

                if (itemSelected !== undefined) {

                    //genericaSistema.uts['nota'] = itemSelected.uts['notaDefault'];

                }
            }

            guardando.current = true;

            if ("hola" === "hola") {

                let _genericasSistema = [...genericasSistema_FORMULARIO_GENERICO_DETALLE]
                const index = findIndexById(rowData.id, _genericasSistema);

                let newGenerica = _genericasSistema[index];

                newGenerica.uts["valorOrig"] = rowData.uts["valor"];
                newGenerica.uts["valor"] = newValue;

                newGenerica.uts = { ...rowData.uts };

                _genericasSistema[index] = newGenerica;

                console.log("addd", rowData);

                setGenericasSistema_FORMULARIO_GENERICO_DETALLE(_genericasSistema);

            }
            if (1 == 1) {

                await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                    console.log("response222, ", response);


                    let genericaSistemaAffect = response.genericasSistemaAffected.find(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg);

                    if (selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg === genericaSistemaAffect.tg) {

                        //props.onSaveSuccessfull(response.genericasSistemaAffected);

                        let _genericasSistema = [...genericasSistema_FORMULARIO_GENERICO_DETALLE]
                        const index = findIndexById(rowData.id, _genericasSistema);

                        let newGenerica = _genericasSistema[index];


                        if (response.mensaje === "") {

                            _genericasSistema[index].id = response.id;
                            _genericasSistema[index].cti = response.cti;
                            if (response.campoSequenceTg !== "")
                                _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;


                            let newUts = { ...genericaSistemaAffect.uts };

                            newUts["valorOrig"] = rowData.uts["valor"];

                            if (rowData.id > 0) {
                                //rowData.uts[field] = newValue;
                                newGenerica.uts = newUts;

                            }
                            else {
                                newGenerica.id = genericaSistemaAffect.id;
                                newGenerica.cti = genericaSistemaAffect.cti;
                                //rowData.uts[field] = newValue;
                                rowData.uts = newUts;


                            }

                            _genericasSistema[index] = newGenerica;
                            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(_genericasSistema);


                            //setGenericaSistemaDialogFormulario(false);
                            //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                        }
                        else {

                            if (rowData.id > 0) {
                                rowData.uts[field] = newValue;
                                //rowData.uts  = genericaSistemaAffect.uts;
                            }
                            else {
                                rowData.id = response.id;
                                rowData.cti = response.cti;
                                if (response.campoSequenceTg !== "")
                                    rowData.uts[response.campoSequenceTg] = response.sequenceTg;
                                rowData.uts[field] = newValue;

                                /*const index = findIndexById(rowData.id);
                                let _genericasSistema = [...genericasSistema]
         
                                _genericasSistema[index].id = response.id;
                                _genericasSistema[index].cti = response.cti;
                                if (response.campoSequenceTg!=="")
                                _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
         
                                setGenericasSistema(_genericasSistema);*/

                                //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                                //_genericasSistema.unshift(_genericaSistema);
                            }

                        }




                        //toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                    }

                    guardando.current = false;

                });
            }

            /*
            switch (field) {
                case 'quantity':
                case 'price':
                    if (isPositiveInteger(newValue)) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;
    
                default:
                    if (newValue.trim().length > 0) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;
            }*/

        }

        setLoadingData(false);

        if (props.onChangeDataInterno) {

            if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" || selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA") {
                //genericasSistema.forEach(x=>)

            }

        }

    };

    const findIndexById = (id, _genericasSistema) => {

        let index = -1;
        for (let i = 0; i < _genericasSistema.length; i++) {
            if (_genericasSistema[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }


    const selectButtonBodyItemTemplate = (option) => {
        //console.log("option,", option);

        let campoCtiTextoOptionsSelectButton = 'ctiTextovalor';
        let campoOptionsSelectButton = 'valor';

        return <div className="m-0" dangerouslySetInnerHTML={{ __html: option.uts[campoCtiTextoOptionsSelectButton] }} />
        //return <i className={option.icon}></i>;

    }

    const showOverlayPanel = (e, _campo) => {
        let op = genericasSistema_FORMULARIO_GENERICO_NOTAPADRE.find(x => '' + x.uts[campoRespuestaFormatoDiligenciadoRef.current] === _campo)
        op.formRef.toggle(e);
        //console.log(op.formRef);
        //op.formRef.visible=true;
    }

    const generarMensajeValidacionCampo = (metadata) => {

        let campo = metadata.campo;

        let val = genericaSistema['uts'][`${campo}`];

        let tieneMensajeError = submitted && metadata.tipoDato !== "boolean" && !val && metadata.mensajeError !== "";

        let textoError = tieneMensajeError ? "is required. " + metadata.mensajeError : "";

        //console.log("validaciones campos, ", val, tieneMensajeError, textoError, metadata);

        /*
        switch (metadata.tipoDato){
            case "boolean": return (<Checkbox id={`fieldEdit${metadata.tg+'-'+campo}`} checked={ val }  ref={e => metadataRef.columnRef = e} required onChange={(e) => onBooleanChange(e, campo)} className={classNames({ 'p-invalid': submitted && !genericaSistema.ctiTexto })}></Checkbox>); break;
            case "int": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={ val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)} />); break;
            case "double": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={  val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)}  mode="decimal" />); break;
            default: return (<InputText id={`fieldEdit${metadata.tg+'-'+campo}`} value={val } ref={e => metadataRef.columnRef = e} required  onChange={(e) => onInputChange(e, campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />); break;
        }
        */

        return (tieneMensajeError && <small className="p-invalid">{metadata.ctiTexto} {textoError}</small>);
    }

    const onClickBotonCancelar = async (e) => {

        setGuidIntento(newGuid);
        setEditando(false);
        var newGuid = window.crypto.randomUUID();

        console.log("newGuid, ", newGuid);

        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

        if (props.onHideForm) {
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([]);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE([]);
            props.onHideForm(e);
        }
        else {
            lazyParamInit.filters = {};
            let newLazyParamInit = Object.assign({}, lazyParamInit);
            setLazyParams({ ...newLazyParamInit });
            lazyParamsInitSelected.current = newLazyParamInit;
        }

    }




    const savegenericaSistema = async () => {

        //setEditando(true);
        setSubmitting(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        let todoValido = true;

        let newGenericasSistema_FORMULARIO_GENERICO_DETALLE = [...genericasSistema_FORMULARIO_GENERICO_DETALLE];

        newGenericasSistema_FORMULARIO_GENERICO_DETALLE.forEach(gen => {
            gen.uts['ingresado'] = true;
            todoValido = todoValido && gen.uts['valido'];
        });

        if (!todoValido) {
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(newGenericasSistema_FORMULARIO_GENERICO_DETALLE);
            setSubmitting(false);
        }
        else {


            let tgRefOps = selectedTipoGenerica.operacionesCampos
                .find(x => x.seccion === "FORMULARIO_GENERICO_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_COMPLETAR_INTENTO")
            if (tgRefOps) {


                //setSelectedTipoGenerica(newSelectedTipoGenerica);

                let newGenericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
                newGenericaSistema.uts['guidintentoDiligenciamiento'] = guidIntento;

                let genericasSistemaIntento = genericasSistema_FORMULARIO_GENERICO_INTENTO[0];

                let itemOpsCampo = {};

                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === tgRefOps.id) {
                        if (tgRefOps.tgRef === "FMT_VSTA_CLONE_FORMATO_DILIGENCIADO_PARA_COMPLETAR_INGRESO"
                            || tgRefOps.tgRef === "FMT_VSTA_CLONE_FORMATO_DILIGENCIADO_PARA_COMPLETAR_INGRESO"
                        ) {
                            newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaIntento.uts[itemOpsCampo.campotgRef];
                        }
                        else {
                            newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        }
                    }

                }

                let children = newGenericasSistema_FORMULARIO_GENERICO_DETALLE.map(gen => ({ ...gen, formRef: null, columnRef: null, mensajeError: "" }));

                await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema, children).then(response => {

                    if (response.mensaje === "") {


                        setTimeout(() => {

                            setGuidIntento(newGuid);
                            setEditando(false);

                            console.log("newGuid, ", newGuid);

                            establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

                            lazyParamInit.filters = {};
                            let newLazyParamInit = Object.assign({}, lazyParamInit);
                            setLazyParams({ ...newLazyParamInit });
                            lazyParamsInitSelected.current = newLazyParamInit;

                            setSubmitting(false);

                            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

                            if (props.onSaveSuccessful) {
                                props.onSaveSuccessful(newGenericaSistema, -1, response.genericasSistemaAffected);
                            }

                        }, 100);



                        //setGenericasSistema(_genericasSistema);
                        //setGenericaSistemaDialog(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {

                        setSubmitting(false);

                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                    }

                });



            }

        }





        /*
     
     
     
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
     
    console.log("sende, ", genericaSistema);
     
    let dialog = genericaSistemaDialogRef.current;
     
    */



    }

    const onEditarFormularioFactura = async (e) => {

        setSubmitting(true);
        setCreandoFormulario(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        let tgRefOps = selectedTipoGenerica.operacionesCampos
            .find(x => x.seccion === "FORMULARIO_GENERICO_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")
        if (tgRefOps) {


            //setSelectedTipoGenerica(newSelectedTipoGenerica);

            let newGenericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
            newGenericaSistema.uts['guidintentoDiligenciamiento'] = newGuid;

            //let genericasSistemaConsolidado = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    if (itemOpsCampo.campotgRef === "matricula" && selectedTipoGenerica.tg === "FMT_FORMATO_EVALUACION-RAP_MOODLE") {
                        // esto hay que organizarlo mejor
                        //newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotgRef];
                    }
                    else
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                }
            }

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
                }
    
            }*/


            setLoadingLazyData(true);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema).then(response => {

                setCreandoFormulario(false);
                if (response.mensaje === "") {


                    setTimeout(() => {

                        setGuidIntento(newGuid);
                        setEditando(true);

                        console.log("newGuid, ", newGuid);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, true, newGuid);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                        setSubmitting(false);

                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado1', life: 3000 });

                    }, 100);



                    //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    setSubmitting(false);
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

            });



        }


        /*
    
     
     
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
    
    console.log("sende, ", genericaSistema);
    
    let dialog = genericaSistemaDialogRef.current;
    
    */



    }


    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
        savegenericaSistema();
    };

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };


    const genericaSistemaDialogFooter = () => {

        //console.log("editando, ", editando);
        if (editando) {

            return (<>



                {
                    (function () {
                        //rounded text raised                         
                        if (genericasSistema_FORMULARIO_GENERICO_DETALLE && genericasSistema_FORMULARIO_GENERICO_DETALLE.length > 0) {
                            return (<Button ref={refBtGuardarDialogFooter} label="Guardar" icon="pi pi-check " outlined className="" onClick={savegenericaSistema} loading={submitting} style={{ minWidth: '10rem' }} />);
                        }
                    })()
                }



            </>);

        }
        else if (props.onHideForm) {
            return (<Button label="Cancelar" outlined icon="pi pi-times" className="" onClick={props.onHideForm} />);
        }
        else {
            return (<></>);
        }


    }

    const onClickEditarFormularioFactura = async () => {

    }

    const FormularioFacturaHeader = () => {

        if (modoEdicion && !editando) {

            if (genericaSistema !== undefined && genericaSistema.tg === "FMT_FORMATO-0"
                //&& genericaSistema.uts["VistaMoodle"] !== undefined && genericaSistema.uts["VistaMoodle"] === "viewUpdateGradeRA"
            ) {




                return (
                    <>
                        <Button label="Iniciar Diligenciamiento" icon="pi pi-pencil" raised={true} outlined onClick={onEditarFormularioFactura}
                            disabled={submitting} />
                    </>
                );
            }
            else {
                return (<></>);
            }

        }
        else if (modoEdicion) {

            return (
                <>
                    <span> Editando</span>
                </>
            );

        }
        else {
            return (
                <>
                    <span>Modo Sólo lectura</span>
                </>
            );
        }
    }

    const onChangeDataInterno = (e, metadataRef) => {
    }

    const onSaveSuccessfullDataTableGenericaCalificacion = (valuesAffected) => {

        var newGuid = window.crypto.randomUUID();
        //console.log("valuesAffected, ", guidVersion.current, valuesAffected);
        //guidVersion.current = window.crypto.randomUUID();

        setSelectedTipoGenerica_FORMULARIO_GENERICO_INTENTO({ ...selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO, version: newGuid });
        setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO({ ...selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO, version: newGuid });
        setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE({ ...selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE, version: newGuid });
        setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE({ ...selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE, version: newGuid });

        setLazyParams({ ...lazyParams });

    }

    //if (!genericaSistemaDialog || etiquetasModulo.length === 0)
    if (genericaSistemaDialog === false) {
        return (<></>);
    }

    else if (genericaSistemaDialog === true &&
        (etiquetasModulo.length === 0
            || selectedTipoGenerica === undefined
            || selectedTipoGenerica.operaciones === undefined
            || (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_GENERICA")
            || selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE === undefined
            || genericasSistema_FORMULARIO_GENERICO_INTENTO === null
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE === null
            || genericasSistema_FORMULARIO_GENERICO_DETALLE === null
            || genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA === null
            || selectedColumns.length === 0)
        //|| metadataGenericaSistemaTgOperaciones.length === 0 || genericaSistema === undefined

    ) {
        return (<div>
            <Toast ref={toast} />
            <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                contentStyle={{
                    height: '95%',          /* Obliga al contenido a estirarse por completo */
                    maxHeight: '95%',       /* Elimina restricciones internas */
                    overflowY: 'auto'        /* Si el contenido desborda, crea scroll aquí dentro */
                }}
                visible={genericaSistemaDialog}
                style={{ width: '99%', height: "100vh", position: 'fixed' }} resizable={false} position='top'
                header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " "} modal className="p-fluid mi-modal-completo"
                footer={(genericaSistemaDialogFooter())}
                onHide={props.onHideForm} closable={props.onHideForm !== undefined}
            >

                Buscando y cargando formato diligenciado... <ProgressSpinner style={{ width: '15px', height: '15px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />

            </Dialog>
        </div>);

    }

    else if (genericaSistemaDialog === true &&
        (etiquetasModulo.length === 0
            || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
            || (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_GENERICA")
            || selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE === undefined
            || genericasSistema_FORMULARIO_GENERICO_INTENTO === null
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE === null
            || genericasSistema_FORMULARIO_GENERICO_DETALLE === null
            || genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA === null
            || selectedColumns.length === 0
            || metadataGenericaSistemaTgOperaciones.length === 0 || genericaSistema === undefined
            || (editando === false && loadingLazyData === false)

        )

    ) {
        let y = "";
        return (<div>
            <Toast ref={toast} />
            <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                contentStyle={{
                    height: '95%',          /* Obliga al contenido a estirarse por completo */
                    maxHeight: '95%',       /* Elimina restricciones internas */
                    overflowY: 'auto'        /* Si el contenido desborda, crea scroll aquí dentro */
                }}
                visible={genericaSistemaDialog}
                style={{ width: '99%', height: "100vh", position: 'fixed' }} resizable={false} position='top'
                header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto} modal className="p-fluid mi-modal-completo"
                footer={(genericaSistemaDialogFooter())}
                onHide={props.onHideForm} closable={props.onHideForm !== undefined}
            >

                Aún no ha diligenciado el formato

                <FormularioFacturaHeader></FormularioFacturaHeader>

            </Dialog>
        </div>);
    }

    else if (genericaSistemaDialog === true &&
        (etiquetasModulo.length === 0
            || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
            || (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_GENERICA")
            || selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE === undefined
            || genericasSistema_FORMULARIO_GENERICO_INTENTO === null
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE === null
            || genericasSistema_FORMULARIO_GENERICO_DETALLE === null
            || genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA === null
            || selectedColumns.length === 0
            || metadataGenericaSistemaTgOperaciones.length === 0 || genericaSistema === undefined
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.length === 0
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE.length === 0
            || genericasSistema_FORMULARIO_GENERICO_DETALLE.length === 0
            || (validarOptionsSelectButtonRef.current === true && genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.length === 0)
            || (editando === true && loadingLazyData === true)
        )

    ) {
        if (selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE !== null && selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.length > 0) {
            console.log("hola");
        }

        let texto = "Cargando datos";

        if (creandoFormulario) {
            texto = "Creando Formulario";
        }

        return (<div>
            <Toast ref={toast} />
            <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                contentStyle={{
                    height: '95%',          /* Obliga al contenido a estirarse por completo */
                    maxHeight: '95%',       /* Elimina restricciones internas */
                    overflowY: 'auto'        /* Si el contenido desborda, crea scroll aquí dentro */
                }}
                visible={genericaSistemaDialog}
                style={{ width: '99%', height: "100vh", position: 'fixed' }} resizable={false} position='top'
                header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto} modal className="p-fluid mi-modal-completo"
                footer={(genericaSistemaDialogFooter())}
                onHide={props.onHideForm} closable={props.onHideForm !== undefined}
            >

                {texto}

                <ProgressSpinner style={{ width: '15px', height: '15px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />

            </Dialog>
        </div>);


    }

    else if (!modoEdicion)
        //console.log("selectedTipoGenerica, ", selectedTipoGenerica);
        //console.log("metadataGenericaSistemaForm, ", metadataGenericaSistemaForm);
        return (
            <div>
                <Toast ref={toast} />

                <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                    contentStyle={{
                        height: '95%',          /* Obliga al contenido a estirarse por completo */
                        maxHeight: '95%',       /* Elimina restricciones internas */
                        overflowY: 'auto'        /* Si el contenido desborda, crea scroll aquí dentro */
                    }}
                    visible={genericaSistemaDialog}
                    style={{ width: '99%', height: "100vh", position: 'fixed' }} resizable={false} position='top'
                    header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid mi-modal-completo"
                    footer={(genericaSistemaDialogFooter())}
                    onHide={props.onHideForm} closable={props.onHideForm !== undefined}
                >

                    <FormularioFacturaHeader></FormularioFacturaHeader>

                    {generarCabeceraFormulario()}

                    {generarSegmentosFormularioGenericaSistemaSeleccionada()}

                </Dialog>
            </div>
        );
    /*
    
    <DataTableGenericaPreguntaFormato canEditRow={false} selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                        onSelectedItem={onSelectedItem} onChangeDataInterno={onChangeDataInterno}
                        metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                        //metadataRef={metadataGenericaSistemaForm}
                        genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                        camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                        onSaveSuccessfull={onSaveSuccessfullDataTableGenericaCalificacion}
                    >
    
                    </DataTableGenericaPreguntaFormato>
     <DataTableListGenericaRaw selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                            //onSelectedItem={onSelectedItem} 
                            //onChangeDataInterno={onChangeDataInterno} 
                            metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                            genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                            camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                        >
     
                        </DataTableListGenericaRaw>
    */


    else {

        return (
            <div>
                <Toast ref={toast} />
                fff

                <Dialog id="dialogGenericaSistemaForm" ref={genericaSistemaDialogRef}
                    contentStyle={{
                        height: '95%',          /* Obliga al contenido a estirarse por completo */
                        maxHeight: '95%',       /* Elimina restricciones internas */
                        overflowY: 'auto'        /* Si el contenido desborda, crea scroll aquí dentro */
                    }}

                    pt={{
                        footer: { className: 'h-6rem align-content-center' }
                    }}
                    visible={genericaSistemaDialog}
                    style={{ width: '99%', height: "100vh", position: 'fixed' }} resizable={false} position='top'
                    header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid mi-modal-completo"
                    footer={genericaSistemaDialogFooter()}
                    onHide={props.onHideForm ? props.onHideForm : undefined}
                    closable={props.onHideForm !== undefined}
                >
                    <div className="marcoFormulario">
                        <FormularioFacturaHeader></FormularioFacturaHeader>

                        {generarCabeceraFormulario()}

                        {generarSegmentosFormularioGenericaSistemaSeleccionada()}

                    </div>

                </Dialog>
            </div>
        );
        /*
    
        <DataTableGenericaPreguntaFormato canEditRow={modoEdicion && editando} selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                        onSelectedItem={onSelectedItem} onChangeDataInterno={onChangeDataInterno}
                        metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                        //metadataRef={metadataGenericaSistemaForm}
                        genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                        camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                        onSaveSuccessfull={onSaveSuccessfullDataTableGenericaCalificacion}
                    >
                     </DataTableGenericaPreguntaFormato>
    
              <DataTableListGenericaRaw selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                        //onSelectedItem={onSelectedItem} 
                        //onChangeDataInterno={onChangeDataInterno} 
                        metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                        genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                        camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                    >
    
                    </DataTableListGenericaRaw>
         */


    }

});

export default FormularioGenerico;
